import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-stone-100 px-5 py-20 sm:py-28" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-18" data-mp="pm2bpwd5bfh1">
        <h2 className="text-center text-2xl font-bold leading-tight tracking-tight text-stone-900 sm:text-3xl" data-id="element-19" data-mp="avld0krwb3nu">
          <span aria-hidden="true" data-id="element-20" data-mp="ftej7dt77xo4">🎁 </span>5 Exclusive Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-stone-600" data-id="element-21" data-mp="1un35lus01xc">
          Valued at{' '}
          <span className="font-semibold text-stone-500 line-through" data-id="element-22" data-mp="5w0cw70zop9j">
            $148 USD
          </span>{' '}
          — Included <span className="font-semibold text-orange-600" data-id="element-23" data-mp="3o2epa1jm0r5t">FREE</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-24" data-mp="3t0g58dlqoad2">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-xl border border-stone-200 bg-white p-4" data-id="element-25" data-mp="1ma8nd38hj84t" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-orange-600 text-sm font-bold text-white" data-id="element-26" data-mp="1r8tca6iae5dy">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-14 w-11 shrink-0 rounded object-cover" data-id="element-27" data-mp="3dek353i0gdkr" />
              <div data-id="element-28" data-mp="3n5ercdethn8u">
                <h3 className="text-sm font-semibold leading-snug text-stone-900" data-id="element-29" data-mp="3n4wmwti042pu">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] font-semibold" data-id="element-30" data-mp="2zfu7lsaualyi">
                  <span className="text-stone-500 line-through" data-id="element-31" data-mp="2uh97dsvl82a2">
                    was {bonus.was}
                  </span>{' '}
                  <span className="text-orange-600" data-id="element-32" data-mp="38htlibqk59x8">FREE</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}